const decryptEmail = (encoded) => {
  return atob(encoded);
};

export default decryptEmail;
